import { useKpiUnit } from 'src/hooks/useKpiUnit';

export const useCPULabel = () => {
  const { isEuro } = useKpiUnit();

  return isEuro ? 'Cost per revenue' : 'Cost per unit';
};
